import React, {Fragment, useState, useEffect} from 'react';

const RteNotificaciones = ({nombre, items}) => {
  const [fechaActual, setFechaActual] = useState('');

  useEffect(() => {
    let fecha = new Date();
    let dia = fecha.getDate();
    let mes = fecha.getMonth() + 1; // Sumar 1 porque los meses son de 0 a 11
    const anio = fecha.getFullYear();

    setFechaActual(`${dia}/${mes}/${anio}`);
  }, []);

    return (
        <div>
            <h4>{nombre} al {fechaActual}</h4>
            <div className="row">
                <div className="col-sm-2 fw-bold">Fecha</div>
                <div className="col-sm-6 fw-bold">Asunto</div>
                <div className="col-sm-4 fw-bold">Destinatario</div>
            </div>    

            {(() => {
            let lastNotificador = null;
            let toggle = false;
            
            return items.map((item, index) => {
                // si cambia el rol respecto al anterior, cambio cabecera
                toggle = item.notificador_id !== lastNotificador
                if (item.notificador_id !== lastNotificador) {
                lastNotificador = item.notificador_id;
                }
                                
                return (
                <Fragment key={index}>
                    {
                    toggle && (
                    <div>
                        <h5 className='p-0 text-uppercase'>{item.notificador}</h5>
                    </div>
                    )
                    }
                    <div className="row fs-6">
                        <div className="col-sm-2">
                            {item.fecha_envio}
                        </div>
                        <div className="col-sm-6">
                            {item.asunto}
                        </div>
                        <div className="col-sm-4 text-uppercase">
                            {item.notificado}
                        </div>
                    </div>
                </Fragment>
                )
            })
            })()}

            {/* <table className="table table-sm align-items-center mb-0 table-hover">
              <thead>
                <tr>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder ">Fecha</th>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder ">Asunto</th>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder ">Destinatario</th>
                </tr>
              </thead>
              <tbody>
              {(() => {
                let lastNotificador = null;
                let toggle = false;
              
                return items.map((item, index) => {
                  // si cambia el rol respecto al anterior, cambio cabecera
                  toggle = item.notificador_id !== lastNotificador
                  if (item.notificador_id !== lastNotificador) {
                    lastNotificador = item.notificador_id;
                  }
                                    
                  return (
                    <Fragment key={index}>
                      {
                        toggle && (
                        <tr>
                          <td className='p-0' colSpan={3}>
                            <h5 className='p-0'>{item.notificador}</h5>
                          </td>
                        </tr>
                        )
                      }
                      <tr>
                        <td className='p-0'>
                          {item.fecha_envio}
                        </td>
                        <td className='p-0'>
                          {item.asunto}{item.asunto}{item.asunto}{item.asunto}
                        </td>
                        <td className='p-0 text-uppercase'>
                          {item.notificado}
                        </td>
                      </tr>
                    </Fragment>
                  )
                })
                })()}
              </tbody>
            </table> */}
        </div>
    );
};

export default RteNotificaciones;